
import { MouseEvent } from "react";
import { CalendarIcon, CheckIcon, DotsVerticalIcon, PencilAltIcon } from "@heroicons/react/outline";
import { SignatureField } from "../interfaces";

interface Props {
  field: SignatureField;
  recipient: number;
  position?: { top: number, left: number };
  offset?: { top: number, left: number };
  currentDraggingField?: { field: SignatureField, recipient: number };
  onStartDragging?: (field: SignatureField, recipient: number, offset: { left: number, top: number }) => void;
}

const NAME_MAP = {
  "SIGNATURE": "Signature",
  "INITIALS": "Initials",
  "DATE": "Date Signed",
  "TEXT": "Text",
  "CHECKBOX": "Checkbox",
}

const ICON_MAP = {
  "SIGNATURE": <PencilAltIcon className="w-4 h-4 mr-2 flex-shrink-0" />,
  "INITIALS": <div className="w-4 h-4 mr-2 font-gilroy text-xs underline flex-shrink-0 text-center">AB</div>,
  "DATE": <CalendarIcon className="w-4 h-4 mr-2 flex-shrink-0" />,
  "TEXT": <div className="w-4 h-4 mr-2 font-gilroy text-xs flex-shrink-0 text-center">Tt</div>,
  "CHECKBOX": <CheckIcon className="w-4 h-4 mr-2 border border-black rounded flex-shrink-0" />,
}

function SignaturesDraggableField(props: Props) {
  const { field: currentField, recipient: currentRecipient } = props.currentDraggingField ?? { field: undefined, recipient: undefined };

  function handleStartDragging(e: MouseEvent<HTMLDivElement>) {
    e.preventDefault();

    const rect = e.currentTarget.getBoundingClientRect();
    const left = e.clientX - rect.left;
    const top = e.clientY - rect.top;

    if (!props.onStartDragging)
      return

    props.onStartDragging?.(props.field, props.recipient, { left, top });
  }

  if (currentField === props.field && currentRecipient === props.recipient)
    return <div className=" w-full h-10 bg-gray-200 rounded shadow-inner" />;

  const offsetPosition = (() => {
    if (!props.position || !props.offset)
      return {}

    return {
      left: props.position.left - props.offset.left,
      top: props.position.top - props.offset.top,
    }
  })();

  return (
    <div className={`h-10 px-1 py-2 bg-gray-50 rounded border border-gray-400 shadow flex items-center text-sm text-gray-600 font-semibold w-[308px] select-none ${!!props.position ? "absolute cursor-grabbing z-40" : "relative cursor-grab"}`} style={{ ...offsetPosition }} onMouseDown={handleStartDragging}>
      {ICON_MAP[props.field]}
      {NAME_MAP[props.field]}
      <DotsVerticalIcon className="h-4 ml-auto" />
      <DotsVerticalIcon className="-ml-3 h-4" />
    </div>
  )

}

export default SignaturesDraggableField;
